<template>
  <div class="product-price__root">
    <div class="collection-product__currency">
      {{ $priceFormat({amount:price, decimalCount:0 }) }} ₽
    </div>

    <div
      v-if="Boolean(oldPrice && oldPrice > price)"
      class="collection-product__old"
    >
      {{ $priceFormat({amount:oldPrice, decimalCount:0 }) }} ₽
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNuxtApp } from '#app';

const { price, oldPrice } = defineProps<{
	price:number;
	oldPrice:number | undefined;
}>();
const { $priceFormat } = useNuxtApp();
</script>

<style lang="scss">
.collection-product__old {
  font-size: 24px;
  line-height: 31px;
  text-align: right;
  text-decoration-line: line-through;
  color: #979797;
  margin-left: 30px;
  min-width: 114px;
  max-width: 114px;
}

.collection-product__currency {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: #000;
}

.product-price__root{
  display: flex;
  flex-direction: column;
}

@media (max-width: 990px) {
  .collection-product__currency {
    font-size: 19px;
    line-height: 25px;
  }
  .collection-product__old {
    font-size: 12px;
    line-height: 17px;
    min-width: initial;
    max-width: initial;
  }
  .collection-product__currency,
  .collection-product__old {
    white-space: nowrap;
  }
}
</style>
